import axios from 'axios'
import router from '../router'
import store from '../store/index'
import * as utils from "@/utils/utils";
import {
  Message
} from 'ant-design-vue';
let loadingInstance = 0 //这里是请求次数 控制loading展示时间
export const Service = axios.create({
  timeout: 70000, // 请求超时时间  
  // 跨域代理
  baseURL: '/api',
  // baseURL: 'https://bbm.amallb2b.com/api', 
  method: 'post',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
})
export const Service1 = axios.create({
  timeout: 70000, // 请求超时时间  
  // 跨域代理
  baseURL: '/wx_api',
  method: 'post',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
})
/** 
 * 请求拦截器
 */
Service.interceptors.request.use(config => {
  loadingInstance += 1
  if (store.state.whetherLoading) {
    store.state.loading = true
  }

  // 添加请求头部信息 token
  config.headers.requestSrc = "WEB"
  if (localStorage.getItem('amall_authorization')) {
    config.headers['Authorization'] = localStorage.getItem('amall_authorization');
  }
  if (localStorage.getItem('amallSystemId')) {
    config.headers['systemId'] = localStorage.getItem('amallSystemId');
  }
  config.headers['type'] = 2
  return config
})

/** 
 * 响应拦截器
 */
Service.interceptors.response.use(response => {
  loadingInstance -= 1
  if (loadingInstance == 0) {
    store.state.loading = false
  }
  if (response.data.code === 403) {
    Message({
      message: response.data.message,
      type: 'error',
      duration: 3 * 1000
    })
    utils.loginOut();
    return
  }
  if (response.code === 20001 || response.code === 50001 || response.code === 50003 || response.code === 50005 || response.code === 50006) {
    /***
     * 提示框
     */
    Message({
      message: response.data.message,
      type: 'error',
      duration: 3 * 1000
    })
    return
  }
  if (response.data.code == 20000) {
    //获取响应头里面的数据，**Authorization根据你响应头里面的数据获取，并不是唯一值** 
    if (response.headers['authorization']) {
      localStorage.setItem("amall_authorization", response.headers['authorization']);
    }
  }
  return response.data
}, error => {
  loadingInstance -= 1
  if (loadingInstance == 0) {
    store.state.loading = false
  }
  // 登录信息失效 退出登录 
  if (error.response.status === 403 || error.response.status === 401 || error.response.status == 500) {
    utils.loginOut();
  }
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/service/index.js